<div class="registration-container">
    <form [formGroup]="salaryAdvanceRequestForm" (ngSubmit)="submitLeave()" class="form-container">

        <!-- ===================== COMPANY INFORMATION ===================== -->
        <h2 class="section-title">Apply for Salary Advance</h2>
        <div class="form-section grid-2">
            <mat-form-field appearance="outline">
                <mat-label>Employee Number</mat-label>
                <input matInput [value]="empNo" readonly>
            </mat-form-field>              
            <mat-form-field appearance="outline" class="reason-field">
                <mat-label>Amount</mat-label>
                 <input matInput formControlName="amount" required (keypress)="allowOnlyNumbers($event)">
            </mat-form-field>
       
        <!-- </div>
        <div class="form-section grid-2"> -->
            <mat-form-field appearance="outline">
                <mat-label>Return Date</mat-label>
                <input matInput [matDatepicker]="fromPicker" formControlName="return_date" required>
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
                <!-- <mat-error *ngIf="salaryAdvanceRequestForm.get('return_date')?.hasError('required')">
                    Start Date is required
                </mat-error> -->
            </mat-form-field>
            <!-- <mat-form-field appearance="outline">
                <mat-label>Request Date</mat-label>
                <input matInput [matDatepicker]="toPicker" formControlName="request_date" required>
                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
                <mat-error *ngIf="salaryAdvanceRequestForm.get('request_date')?.hasError('required')">
                    End Date is required
                </mat-error>
            </mat-form-field> -->
        </div>
        <div class="form-section grid-2">
            <mat-form-field appearance="outline" class="reason-field">
                <mat-label>Reason</mat-label>
                <textarea style="height: 100px !important;" matInput formControlName="reason" rows="3" required></textarea>
            </mat-form-field>
        </div>
        <div class="form-actions">
            <button mat-raised-button color="primary" type="submit" class="submit-vendor-btn">
                <span *ngIf="!isLoading">Apply</span>
                <span *ngIf="isLoading" class="loader"></span>
            </button>
        </div>
    </form>
</div>